import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';

interface SectionCard {
    heading: string;
}

export const SectionCard: FC<SectionCard> = ({ children, heading }) => {
    return (
        <Box>
            <Typography fontSize="20px" fontWeight="600" color="#434341" lineHeight="28px">
                {heading}
            </Typography>
            <Box height="1px" width="100%" bgcolor="#F18F34" marginY="8px" />
            <Flex flexDirection="column" gap="16px">
                {children}
            </Flex>
        </Box>
    );
};
